import axios from "axios";

const slack = axios.create({
  baseURL: "",
  timeout: 600000,
});

export default {
  notify: async (
    message,
    jsonCode,
    error = { error: "no error to display" }
  ) => {
    try {
      await slack.post(
        "https://hooks.slack.com/services/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",
        JSON.stringify({
          username: "notify-bot",
          channel: "#notify",
          text:
            message +
            " ```" +
            JSON.stringify(jsonCode) +
            "``` ```" +
            JSON.stringify(error) +
            "```",
          icon_emoji: ":alien:",
          mrkdwn: true,
        }),
        {
          withCredentials: false,
          transformRequest: [
            (data, headers) => {
              delete headers.post["Content-Type"];
              return data;
            },
          ],
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
};
